import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuick from '@/pages/home/components/CategoryQuick';
import TopRanking from '@/pages/home/components/TopRanking';
import MovieCard from '@/components/feature/MovieCard';
import NewsCard from '@/components/feature/NewsCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { movies } from '@/mocks/movies';
import { newsList } from '@/mocks/news';

export default function Home() {
  const featured = movies.filter((m) => m.featured).slice(0, 5);
  const latestMovies = [...movies].sort((a, b) => b.year - a.year || b.popularity - a.popularity).slice(0, 10);
  const topRanking = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 6);
  const latestNews = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 4);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <CategoryQuick />

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
        <div className="max-w-screen mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <SectionHeading
                title="最新电影推荐"
                subtitle="按上映时间为你精选，及时更新院线热片"
                moreTo="/movies"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
                {latestMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </div>

            <div className="lg:col-span-1">
              <TopRanking movies={topRanking} />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
        <div className="max-w-screen mx-auto">
          <SectionHeading
            title="最新电影资讯"
            subtitle="影评、业内动态、奖项与票房，一站了解行业前沿"
            moreTo="/news"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            {latestNews.map((article) => (
              <NewsCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20background%20of%20a%20dark%20cinema%20hall%20with%20rows%20of%20empty%20seats%20and%20a%20huge%20glowing%20screen%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric%20wide%20banner&width=1600&height=600&seq=home-cta-band&orientation=landscape"
            alt="午夜电影网 观影氛围"
            title="午夜电影网 - 沉浸式观影体验"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/60"></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-8 py-14 md:py-20">
          <div className="max-w-screen mx-auto">
            <h2 className="text-2xl md:text-4xl font-black text-foreground-950 mb-3 max-w-xl leading-tight">
              每一个深夜，都有好电影陪你
            </h2>
            <p className="text-sm md:text-base text-foreground-700 max-w-2xl leading-relaxed mb-6">
              午夜电影网专注为影迷打造纯粹、干净的选片体验。没有冗余的弹窗，没有繁琐的注册，打开就能找到你想看的那一部。按类型、年份、地区、评分自由筛选，让每一次点开都值得。
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/movies"
                className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
              >
                开始选片
              </Link>
              <Link
                to="/about"
                className="px-5 py-2.5 rounded-md border border-background-400/60 hover:border-primary-500 text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap"
              >
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}